import { QuizTestAttempt, QuizTestAttemptDTO } from '@/modules/bhp/models/QuizTest';

export abstract class QuizListDto {
    quantity!: number;
    items!: QuizTestAttemptDTO[];
    page!: number;
}

export class QuizList extends QuizListDto {
    constructor(dto: QuizListDto) {
        super();
        dto!.items = dto!.items!.map(item => new QuizTestAttempt(item));
        Object.assign(this, dto);
    }
}